<div class="container" *ngIf="this.favTournaments?.length > 0">
  <div class="header" (click)="toggleLeagueMenu()">
    <div class="header-text whiteText">Favourite Leagues</div>
    <div class="arrow-icon" [ngClass]="{ up: isOpenLeagueMenu, down: !isOpenLeagueMenu }"></div>
  </div>
  <div class="content" [ngClass]="{ 'close-fav': !isOpenLeagueMenu }">
    <ng-container *ngFor="let league of this.favTournaments">
      <div class="item fav-box">
        <div class="left">
          <div class="league">
            <image-loader-utils url="star" extraClasses="fav-left-menu-icon mr-0"></image-loader-utils>
          </div>
        </div>
        <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
          <ng-container *ngSwitchCase="'wettarena'">
            <div class="mid" (click)="openLeague(league)" matTooltip="{{ league.catname }} > {{ league.tourname }}">
              <div class="fav-mid">{{ league.catname }} > {{ league.tourname }}</div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'b500'">
            <div class="mid" (click)="openLeague(league)" matTooltip="{{ league.catname }} > {{ league.tourname }}">
              <div class="fav-mid">{{ league.catname }} > {{ league.tourname }}</div>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="fav-mid" (click)="openLeague(league)" matTooltip="{{ league.catname }} > {{ league.catname }}">{{ league.tourname }}</div>
          </ng-container>
        </ng-container>
        <div class="right" (click)="openLeague(league)">{{ league.count }}</div>
      </div>
    </ng-container>
  </div>
</div>
